var _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRocket = function SvgRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.515 4.72C24.223 17.056 18.8 33.62 20.672 50.05l1.593 13.972a3.69 3.69 0 0 0 3.715 3.28l27.972-.268a3.867 3.867 0 0 0 3.778-3.352l1.858-14.005C61.772 33.21 56.66 16.747 45.6 4.623l-2.233-2.447c-1.481-1.624-4.06-1.6-5.572.053l-2.28 2.49Zm4.666 39.776c5.213-.05 9.479-4.32 9.528-9.536a9.229 9.229 0 0 0-9.35-9.356c-5.213.05-9.479 4.32-9.528 9.537a9.229 9.229 0 0 0 9.35 9.355Z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.72 64.647a1.89 1.89 0 0 0-.014 1.403l5.388 13.753c.618 1.577 2.858 1.556 3.506-.034l5.648-13.859a1.89 1.89 0 0 0 .014-1.403c-6.806-17.374-7.406-17.368-14.542.14Z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.253 77.459c.126 1.913-2.355 2.82-3.44 1.257l-8.482-12.21a1.885 1.885 0 0 1-.089-1.992c12.962-23.308 10.814-5.327 12.011 12.945Z",
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.809 64.005a1.898 1.898 0 0 1-.16 1.93l-8.54 12.127c-1.13 1.605-3.625.7-3.414-1.238 1.907-17.444.739-35.914 12.114-12.819Z",
    fill: "url(#d)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 40,
    y1: 0.974,
    x2: 40,
    y2: 80.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13ADC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13ADC7",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 40.129,
    y1: 51.496,
    x2: 40.411,
    y2: 80.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F46837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46837",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 40.129,
    y1: 51.496,
    x2: 40.411,
    y2: 80.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F46837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46837",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 40.129,
    y1: 51.496,
    x2: 40.411,
    y2: 80.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F46837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46837",
    stopOpacity: 0.2
  })))));
};

export { SvgRocket as ReactComponent };
export default "data:image/svg+xml;base64,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";